<template>
<div id="content">
		<div class="bg-container">
			<div v-if="showModal" class="download-tip-modal" @touchmove.prevent="" @mousewheel.prevent="">
				<div class="wxtip-icon"></div>
				<div class="wxtip-txt">{{$t("点击右上角#!!!#src/pages/H5/Cloud/components/tip/guide.vue_1")}}{{inTocaApp}}<br>{{$t("选择在#!!!#src/pages/H5/Cloud/components/tip/guide.vue_1")}}{{defaultBrower}}{{$t("浏览器中打开#!!!#src/pages/H5/Cloud/components/tip/guide.vue_1")}}				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { intl } from 'tci18n-vue2'
const PLATFROM = {
  IOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/,
  MOBILE:
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
};
import { mapState } from 'vuex';

export default {
  name: 'Guide',

  data() {
    return {
      showModal: false,
      inTocaApp: '',
      defaultBrower: '',
      showDownloadBtn: true,
      pageUrl: window.location.origin + '/mSite',
      is_iOS: !!navigator.userAgent.match(PLATFROM.IOS),
      is_Android:
      navigator.userAgent.indexOf('Android') > -1 ||
      navigator.userAgent.indexOf('Linux') > -1,
      is_inMobile: !!navigator.userAgent.match(PLATFROM.MOBILE),
      is_weixin:
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger',
      is_inTocaApp: navigator.userAgent.toLowerCase().indexOf('toca') !== -1,
      showGifInIOS: false
    };
  },
  created() {},
  mounted() {
    this.pageInit();
  },
  methods: {
    // 判断中间页 控件展示逻辑
    pageInit() {
      // 是否是移动端
      // if (this.is_inMobile) {
      // 是否在TocaApp内
      this.inTocaApp = '';
      // 是否在微信/企微内
      if (this.is_weixin) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }

      // 是否是iOS平台
      if (this.is_iOS) {
        this.defaultBrower = 'Safari';
        this.showGifInIOS = true;
      } else {
        this.defaultBrower = intl.$t("默认#!!!#src/pages/H5/Cloud/components/tip/guide.vue_1");
        this.showGifInIOS = false;
      }
      // } else {
      // 	this.showModal = false
      // 	this.showDownloadBtn = false
      // 	this.showGifInIOS = false
      // }
    }
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
      isInToca: (state) => state.isInToca
    })
  }
};
</script>

<style lang="scss">
#content {
	z-index: 99999;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	overflow: scroll;
	overscroll-behavior: none;
}

// 蒙层
.download-tip-modal {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	overscroll-behavior: none;

	.wxtip-icon {
		width: 3rem;
		height: 4.5rem;
		background: url(@/assets/h5/weixin-tip.png) no-repeat;
		background-size: contain;
		display: block;
		position: absolute;
		right: 2rem;
		top: 0.5rem;
	}

	.wxtip-txt {
		position: absolute;
		text-align: right;
		width: 100%;
		top: 5rem;
		right: 2rem;
		color: #fff;
		font-size: 22px;
		line-height: 2.2rem;
		font-weight: 700;
	}
}

// 背景图片
.bg-container {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
}
</style>
